import { tv } from 'tailwind-variants';

export const styles = tv({
  slots: {
    container:
      'flex w-full flex-col gap-6 lg:flex-row lg:items-center lg:justify-between',
    ratingBlock: 'flex flex-col gap-3'
  }
});
